export const itiCoursesList = [
  { "AC Technician": "AC Technician" },
  { "Automobile Technician": "Automobile Technician" },
  { "Boiler Attendant": "Boiler Attendant" },
  { Carpenter: "Carpenter" },
  { "CCTV Technicians": "CCTV Technicians" },
  {
    "Central Aircondition Plant Mechanic":
      "Central Aircondition Plant Mechanic",
  },
  { "Chemical Engineering": "Chemical Engineering" },
  { "Civil Engineering": "Civil Engineering" },
  { "CNC Programmer Operator": "CNC Programmer Operator" },
  {
    "Computer Hardware and Network Maintenance":
      "Computer Hardware and Network Maintenance",
  },
  { Construction: "Construction" },
  { "COP A": "COP A" },
  { "Digital Electronics": "Digital Electronics" },
  { "Draughtsman (Civil)": "Draughtsman (Civil)" },
  { "Draughtsman (Mechanical)": "Draughtsman (Mechanical)" },
  { "Drone Instructor": "Drone Instructor" },
  { "Drone Pilot": "Drone Pilot" },
  {
    "Electrical and Electronics Engineering (EEE)":
      "Electrical and Electronics Engineering (EEE)",
  },
  { "Electrical Engineering": "Electrical Engineering" },
  { Electrician: "Electrician" },
  { "Electronics Engineering": "Electronics Engineering" },
  { "Electronics Mechanic": "Electronics Mechanic" },
  { Fabrication: "Fabrication" },
  { "Fiber Optic Technician": "Fiber Optic Technician" },
  { Fireman: "Fireman" },
  { "Fire Technician": "Fire Technician" },
  { Fitter: "Fitter" },
  { "Fitter (Automotive)": "Fitter (Automotive)" },
  { "Fitter (Furniture)": "Fitter (Furniture)" },
  { "Food Production (General)": "Food Production (General)" },
  { Foundryman: "Foundryman" },
  { "Instrument Mechanic": "Instrument Mechanic" },
  { "Interior Design": "Interior Design" },
  { "Leather and Leather Goods": "Leather and Leather Goods" },
  { "Machine Operator": "Machine Operator" },
  { Machinist: "Machinist" },
  { Mason: "Mason" },
  { "Mechanic (Motor Vehicle)": "Mechanic (Motor Vehicle)" },
  { "Mechanic Diesel": "Mechanic Diesel" },
  { "Mechanic Tractor": "Mechanic Tractor" },
  { Mechanical: "Mechanical" },
  { "Mechanical Engineering": "Mechanical Engineering" },
  { "Medical Electronics": "Medical Electronics" },
  { Mining: "Mining" },
  { "Mobile Repair Technician": "Mobile Repair Technician" },
  { "Moulding Operator": "Moulding Operator" },
  { "Multi Skilled Technician": "Multi Skilled Technician" },
  { "Painting General": "Painting General" },
  { "Paints and Coating": "Paints and Coating" },
  { "Pest Control Technician": "Pest Control Technician" },
  { "Plastic Processing Operator": "Plastic Processing Operator" },
  { Plumber: "Plumber" },
  { "Printing Technology": "Printing Technology" },
  {
    "Refrigeration and Air Conditioning Technician":
      "Refrigeration and Air Conditioning Technician",
  },
  { "RO Technician": "RO Technician" },
  { "Sewing Machine Operator": "Sewing Machine Operator" },
  { "Sheet Metal Worker": "Sheet Metal Worker" },
  {
    "Solar Panel Installation Technician":
      "Solar Panel Installation Technician",
  },
  {
    "Tool and Die Maker (Dies and Moulds)":
      "Tool and Die Maker (Dies and Moulds)",
  },
  { Turner: "Turner" },
  { "TV Technicians": "TV Technicians" },
  { "Warehouse Associate": "Warehouse Associate" },
  { "Washing Machine Technician": "Washing Machine Technician" },
  { Welder: "Welder" },
];
